import script from "./MediaAdditionDeletion.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaAdditionDeletion.vue?vue&type=script&setup=true&lang=js"

import "./MediaAdditionDeletion.vue?vue&type=style&index=0&id=1d4b41ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4b41ce"]])

export default __exports__